import type { StudioSystemType } from 'types/studio/items'

type ModuleGridWithFacetSnap = {
  cellsActive?: unknown
  floatingOnFacetOnChange?: (editor: unknown, skipRemoveFloatingObject?: boolean) => boolean
}

/**
 * Re-run Studio facet snapping so `grid.facet` matches roofs in the scene before outline validation.
 * A spatial OsFacet can exist while panel groups are not yet linked (or were placed before the roof).
 */
export function refreshVanDerValkModuleGridFacetAttachments(system: StudioSystemType): void {
  const editor = window.editor
  if (!editor || system.mounting !== 'vanDerValk') {
    return
  }
  for (const grid of system.moduleGrids()) {
    const mg = grid as ModuleGridWithFacetSnap
    const cells = mg.cellsActive
    if (!Array.isArray(cells) || cells.length === 0) {
      continue
    }
    if (typeof mg.floatingOnFacetOnChange === 'function') {
      mg.floatingOnFacetOnChange(editor, false)
    }
  }
}
